module.exports = __webpack_public_path__ + "img/icon-business-account.99b80f3c.svg";